<a class="btn-icon block relative"
   [routerLink]="['/wishlist']"
   (click)="close()"
   title="wishlist">
    <fa-icon [icon]="heart"></fa-icon>
    <span class='md:inline text-sm ml-2 text-gray-600' [class.hidden]="!showLabel">Wishlist</span>
</a>
